import { useMsal } from '@azure/msal-react'
import React, {useEffect, useState } from 'react'

import { IdleTimeOut } from '../../idletimeoutConfig.ts'
import { isTokenExpired,logoutUserIfExpired} from '../../tokenUtils.ts'
import '../tokenexpiration/TokenExpirationHandlerPopup.css'

const TokenExpirationHandler= (): React.JSX.Element | null => {
  const [showPopup, setShowPopup] = useState(false)
  const { instance } = useMsal()
  
    // Idle timer state
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [idleTime, setIdleTime] = useState(0)
    const idleTimeout = IdleTimeOut // 1 hour in milliseconds (60 minutes)

  useEffect(() => {
      const resetIdleTimer = () => setIdleTime(0)
      const handleActivity = () => resetIdleTimer() // Reset idle time on activity
  
      // Add event listeners for user activity
      window.addEventListener('mousemove', handleActivity)
      window.addEventListener('keydown', handleActivity)
  
      // Increment idle time every second
      const idleTimer = setInterval(() => {
        setIdleTime((prevIdleTime) => prevIdleTime + 1000) // Increment by 1 second
      }, 1000)

      // If idle for more than the timeout duration, log out the user
      if (idleTime >= idleTimeout) { 
        setShowPopup(true)
      }
  
      // Cleanup the event listeners and timer
      return () => {
        clearInterval(idleTimer)
        window.removeEventListener('mousemove', handleActivity)
        window.removeEventListener('keydown', handleActivity)
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idleTime, instance])

    useEffect(() => {
      // Create an async function inside the useEffect to call isTokenExpired
      const checkTokenExpiration = setInterval(async () => {
        if (await isTokenExpired()) {
          setShowPopup(true)
        }
      }, 300000) // Check every 5 minutes interval for checking token expiration
    
      // Cleanup function to clear the interval when the component is unmounted
      return () => clearInterval(checkTokenExpiration)
    }, [])
 
   const handleLogout = () => {
     setShowPopup(false)
     logoutUserIfExpired()
   }

   return showPopup ? (
    <div className='tokenpopup-overlay'>
      <div className='tokenpopup'>
        <h2>Session Expired</h2>
        <p>Your session has expired. Please log in again.</p>
        <button className='btn btn-primary btn-sm btn-border-radius3 whitetext mx-auto mt-2' onClick={handleLogout}>Okay</button>
      </div>
    </div>
  ) : null
}

export default TokenExpirationHandler
